import React, { useEffect } from "react";
import { Checkbox } from "@mantine/core";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";

const EmailAndAgreement = ({ setStepfive, onSubmit }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    // Initialize with default values
    defaultValues: {
      email: "",
      agreeToTerms: false,
    },
  });

  const email = watch("email");
  const agreeToTerms = watch("agreeToTerms");

  // Load saved data from localStorage on component mount
  useEffect(() => {
    const savedData = localStorage.getItem("emailAgreementData");
    if (savedData) {
      const parsedData = JSON.parse(savedData);

      // Set form values from localStorage
      if (parsedData.email) {
        setValue("email", parsedData.email);
      }
      if (parsedData.agreeToTerms !== undefined) {
        setValue("agreeToTerms", parsedData.agreeToTerms);
      }
    }
  }, [setValue]);

  // Auto-save form data to localStorage whenever it changes
  useEffect(() => {
    const subscription = watch((value) => {
      localStorage.setItem("emailAgreementData", JSON.stringify(value));
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  // Update stepfive validation
  useEffect(() => {
    setStepfive(!!(email && agreeToTerms));
  }, [email, agreeToTerms, setStepfive]);

  const handleFormSubmit = (data) => {
    onSubmit(data); // Pass the form data to the parent component
  };

  return (
    <div className="stepper-container email-agreement-wrapper">
      <h3 className="stepper-header">Enter email & agree to terms</h3>
      <form onSubmit={handleSubmit(handleFormSubmit)} id="email-agreement-form">
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <h6 className="sub-header" style={{ color: "#222222" }}>
            Under airline regulations, you may be eligible for compensation if
            your flight was delayed by more than 3 hours due to an
            airline-related issue.
          </h6>

          <div className="custom-input email-agreement-input">
            <label className="input-label">
              Email<span style={{ color: "#de8385" }}> *</span>
            </label>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Email Address is Required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Invalid email address",
                },
              }}
              render={({ field }) => (
                <input
                  {...field}
                  className="input-box"
                  placeholder="Enter your email"
                  type="email"
                />
              )}
            />
            {errors.email && (
              <p className="errormessage">{errors.email.message}</p>
            )}
          </div>

          <div>
            <Controller
              name="agreeToTerms"
              control={control}
              rules={{ required: "You must agree to the terms and conditions" }}
              render={({ field }) => (
                <Checkbox
                  {...field}
                  id="second"
                  checked={field.value}
                  label={
                    <span>
                      I agree to Fly n’ Claim’s{" "}
                      <Link to="/disclaimer" target="blank">
                        Terms and Conditions
                      </Link>{" "}
                      and{" "}
                      <Link to="/privacy" target="blank">
                        Privacy Policy
                      </Link>
                      .
                    </span>
                  }
                />
              )}
            />
            {errors.agreeToTerms && (
              <p className="errormessage">{errors.agreeToTerms.message}</p>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default EmailAndAgreement;
